import { X, SkipForward } from "lucide-react";
import { PAYRUN } from "@/constants/testIds";

export default function SkippedRowsModal({ open, onClose, rows }) {
    if (!open) return null;
    const list = rows || [];
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true">
            <div className="absolute inset-0 bg-black/50" onClick={onClose} />
            <div
                data-testid={PAYRUN.skippedRowsModal}
                className="relative bg-white border border-neutral-200 shadow-2xl w-full max-w-[560px] rounded-[3px]"
            >
                <div className="px-6 py-5 border-b border-neutral-200 flex items-start justify-between">
                    <div className="flex items-start gap-3">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-[2px] bg-neutral-100">
                            <SkipForward size={16} className="text-neutral-500" />
                        </span>
                        <div>
                            <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-500 font-display">
                                Import audit
                            </div>
                            <div className="font-display font-bold text-xl text-[color:var(--kp-charcoal)] mt-0.5">
                                {list.length} row(s) skipped on import
                            </div>
                        </div>
                    </div>
                    <button
                        data-testid={PAYRUN.skippedRowsClose}
                        onClick={onClose}
                        className="p-1 text-neutral-500 hover:text-black"
                    >
                        <X size={16} />
                    </button>
                </div>
                <div className="px-6 py-5 max-h-[420px] overflow-y-auto">
                    {list.length === 0 ? (
                        <div className="text-sm text-neutral-500 italic">No skipped rows recorded.</div>
                    ) : (
                        <ul className="space-y-2">
                            {list.map((r, i) => (
                                <li key={i} className="border border-neutral-200 rounded-[3px] px-3 py-2">
                                    <div className="text-[13px] font-medium text-[color:var(--kp-charcoal)] font-mono-money">
                                        {r.source_name}
                                    </div>
                                    <div className="text-[11px] text-neutral-500 mt-0.5">
                                        Regular {r.hours?.regular ?? 0} · ×1.5 {r.hours?.time_and_half ?? 0} · ×2 {r.hours?.double ?? 0} · Sick {r.hours?.sick ?? 0} · P/H {r.hours?.public_holiday ?? 0}
                                    </div>
                                    <div className="text-[10px] text-neutral-400 mt-1 uppercase tracking-[0.14em] font-display">
                                        Skipped {r.at ? r.at.slice(0, 16).replace("T", " ") : ""}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="px-6 py-3 border-t border-neutral-200 text-[11px] text-neutral-500">
                    These rows were in the biometric paste but the operator explicitly chose to skip them. To include them, run Import Hours again.
                </div>
            </div>
        </div>
    );
}
